"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.PreferredPhoneVerificationMethod=void 0;var r;(function(e){e.Sms="sms",e.Whatsapp="whatsapp"})(r||(exports.PreferredPhoneVerificationMethod=r={}));
//# sourceMappingURL=PreferredPhoneVerificationMethod.js.map
